import PropTypes from 'prop-types';
import styled from '@happymoneyinc/styled-components';
import { meta } from '@happymoneyinc/meta';
import ThemeWrapper from '../utils/ThemeWrapper/index.js';
import { jsx, jsxs } from 'react/jsx-runtime';

var _meta$colors, _meta$colors2, _meta$colors3;
const Toggles = _ref => {
  let {
    className,
    disabled,
    disableDecrement,
    disableIncrement,
    onDecrement,
    onIncrement,
    id,
    testID
  } = _ref;
  return /*#__PURE__*/jsx(ThemeWrapper, {
    children: /*#__PURE__*/jsxs(ToggleButtonsContainer, {
      "data-testid": testID,
      id: id,
      className: className,
      disabled: disabled,
      children: [/*#__PURE__*/jsx(ToggleButton, {
        onClick: onIncrement,
        disabled: disableIncrement,
        $isIncrement: true,
        "data-testid": `${testID}-increment-button`
      }), /*#__PURE__*/jsx(ToggleButton, {
        onClick: onDecrement,
        disabled: disableDecrement,
        "data-testid": `${testID}-decrement-button`
      })]
    })
  });
};
const ToggleButtonsContainer = styled.div`
  flex-direction: column;
  justify-content: space-between;
  display: flex;
  width: 34px;
  height: auto;
  min-height: 72px;
  padding: 4px;
  margin: 0 0 16px 18px;
`;
const ToggleButton = styled.button`
  position: relative;
  display: block;
  width: 26px;
  height: 26px;
  padding: 0;
  margin: 0;
  text-align: center;
  text-decoration: none;
  appearance: none;
  background: none;
  border: 2px solid ${meta === null || meta === void 0 ? void 0 : (_meta$colors = meta.colors) === null || _meta$colors === void 0 ? void 0 : _meta$colors.black};
  border-radius: 50%;
  outline: none;
  transition: transform 150ms ease;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  opacity: ${props => props.disabled ? 0.235 : 'unset'};

  &::before {
    position: absolute;
    right: 0;
    left: 0;
    display: block;
    width: 12px;
    height: 2px;
    margin: -1px auto 0;
    content: '';
    text-align: center;
    background-color: ${meta === null || meta === void 0 ? void 0 : (_meta$colors2 = meta.colors) === null || _meta$colors2 === void 0 ? void 0 : _meta$colors2.black};
    border-radius: 8px;
  }

  &::after {
    position: absolute;
    right: 0;
    left: 0;
    display: ${props => props.$isIncrement ? 'block' : 'none'};
    width: 2px;
    height: 12px;
    margin: -6px auto 0;
    content: '';
    text-align: center;
    background-color: ${meta === null || meta === void 0 ? void 0 : (_meta$colors3 = meta.colors) === null || _meta$colors3 === void 0 ? void 0 : _meta$colors3.black};
    border-radius: 8px;
  }

  &:hover,
  &:focus {
    background: none;
  }

  &:active {
    transform: scale(0.99);
  }
`;
Toggles.propTypes = {
  className: PropTypes.string,
  onDecrement: PropTypes.func.isRequired,
  onIncrement: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  disableIncrement: PropTypes.bool,
  disableDecrement: PropTypes.bool,
  id: PropTypes.string,
  /** data-test-id's to handle elements inside the RangeSlider component */
  testID: PropTypes.string
};
Toggles.defaultProps = {
  className: '',
  disabled: false,
  disableDecrement: false,
  disableIncrement: false,
  id: '',
  testID: 'toggle'
};
var Toggles$1 = Toggles;

export { Toggles$1 as default };
//# sourceMappingURL=Toggles.js.map
